import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { ScriptChangeLogSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { ScriptChangeLogFilterSchema, GetRequestBaseResponseSchema } from "../ea.schema.query";

const base = "scriptChangeLog";
const scl = createEndpointBase(base);

export const scriptChangeLogEndpoints = {
  scriptChangeLogGet: scl({
    method: "GET",
    path: "",
    request: z.object({ filter: ScriptChangeLogFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(ScriptChangeLogSchemas["general"]),
    description: "Retrieves a list of script change logs with filtering support.",
  }),
  scriptChangeLogCount: scl({
    method: "GET",
    path: "count",
    request: z.object({ filter: ScriptChangeLogFilterSchema.optional() }).optional(),
    response: CountResponseSchema,
    description: "Returns the total number of script change logs matching the filters.",
  }),
} as const;
